export default "__VITE_ASSET__2da0612f__"